<template>
  <div
    ref="wrapper"
    class="relative"
  >
    <component
      :is="cardComponent"
      ref="content"
      class="_HijackCard_content_169FV"
      :class="cardClasses"
    >
      <div
        v-if="imageLoaded && locked"
        ref="lockButton"
        class="_HijackCard_lock-button_926tGV absolute pin-t pin-b pin-r pin-l z-10 flex items-center justify-center"
        :class="{ 'hijacked': hijacked }"
      >
        <XButton
          class="rounded px-10 font-bold text-white cursor-pointer"
          :style="{ backgroundColor: hijack.lockButtonColor }"
          @click="handlerAnimation"
        >
          {{ hijack.lockButton }}
        </XButton>
      </div>

      <div class="_HijackCard_overflow_blur_169FV">
        <slot :initHijack="initHijack" />
      </div>
    </component>

    <component
      :is="cardComponent"
      ref="hijacked"
      class="_HijackCard_hijacked_856RV"
      bgColorClass=""
    >
      <component
        :is="hijackType"
        :data="hijack"
        class="w-full"
        @rescuePaid="unLockContent"
      />
    </component>
  </div>
</template>

<script>
import { TweenMax, TimelineMax, Ease } from 'gsap'
import BezierEasing from '@common/utils/gsap/bezierEasing'

import XHijackByFormFields from './hijacks/HijackByFormFields'

export default {
  components: {
    XHijackByFormFields
  },

  props: {
    hijack: {
      type: Object
    },
    cardComponent: {
      type: String
    }
  },

  data () {
    return {
      imageLoaded: false,
      locked: true,
      hijacked: false,
      timeline: null,
      duration: 0.5,
      ease: new Ease(BezierEasing(0.77, 0, 0.175, 1))
    }
  },

  computed: {
    cardClasses () {
      return {
        'unlocked': !this.locked
      }
    },

    hijackType () {
      return 'XHijackByFormFields'
    }
  },

  mounted () {
    this.timeline = new TimelineMax()
  },

  methods: {
    handlerAnimation () {
      this.hijacked = true

      // GET ELEMENTS TO ANIMATE
      const wrapperElm = this.$refs.wrapper
      const contentElem = this.$refs.content.$el
      const hijackedElem = this.$refs.hijacked.$el
      const lockButtonElm = this.$refs.lockButton

      // BOUNDING RECT
      const contentElemRect = contentElem.getBoundingClientRect()
      const hijackedElemRect = hijackedElem.getBoundingClientRect()

      // DURATION
      this.duration = hijackedElemRect.height * 0.001

      // CALCULATE TRANSLATION TOP
      let top = hijackedElemRect.height < contentElemRect.height
        ? Math.abs(hijackedElemRect.height - contentElemRect.height)
        : 0

      // MAKE ANIMATION
      this.timeline
        .to(hijackedElem, this.duration, {
          top: top,
          ease: this.ease,
          onComplete: function () {
            wrapperElm.classList.remove('overflow-hidden')
          }
        })
        .to(lockButtonElm, this.duration, {
          opacity: 0,
          ease: this.ease
        }, '-=' + this.duration)

      if (hijackedElemRect.height > contentElemRect.height) {
        this.timeline
          .to(hijackedElem, this.duration, {
            backgroundColor: '#fff !important'
          }, '-=' + this.duration)
          .to(contentElem, this.duration, {
            height: hijackedElemRect.height,
            ease: this.ease
          }, '-=' + (contentElemRect.height * 0.001))
      }
    },

    lockedContent () {
      this.locked = true

      this.$emit('locked', this.locked)
    },

    unLockContent () {
      const contentElem = this.$refs.content.$el
      const wrapperElm = this.$refs.wrapper
      const hijackedElem = this.$refs.hijacked.$el
      const overflowBlured = this.$refs.content.$el.querySelector('._HijackCard_overflow_blur_169FV')
      const self = this

      this.timeline.reverse()
      contentElem.style.height = null

      TweenMax.to(overflowBlured, this.duration, {
        filter: 'blur(0)',
        margin: 0,
        onStart: function () {
          wrapperElm.classList.add('overflow-hidden')
        },
        onComplete: function () {
          self.hijacked = false
          self.locked = false

          hijackedElem.style.display = 'none'
          contentElem.classList.remove('overflow-hidden')
          wrapperElm.classList.remove('overflow-hidden')

          self.emitRescueEvent()
          self.$emit('unlocked', this.locked)
        }
      }, '-=' + this.duration)
    },

    emitRescueEvent () {
      let data = {}

      switch (this.hijack.type) {
        case 'formFields':
          data = { event: 'fieldsUpdated' }

          break
        case 'registration':
      }

      this.$emit('rescuePaid', data)
    },

    initHijack () {
      this.imageLoaded = true
    }
  }
}
</script>

<style lang="scss">
._HijackCard_content_169FV {
  ._HijackCard_overflow_blur_169FV {
    transition: filter .4s, margin .4s;
    filter: blur(9px);
    margin: -9px;
  }

  &.unlocked {
    height: auto !important;
  }
}

._HijackCard_hijacked_856RV {
  @apply absolute pin-l w-full z-20;

  background-color: rgba(255, 255, 255, .95);
  top: 100%;
  display: flex;
  align-items: center;
  min-height: 300px;
  overflow: visible !important;
}
</style>
